import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom'
import { ErrorState } from '@/components/ui/ErrorState'
import { buttonStyles } from '@/components/ui/Button'

/** Route-level error page: keeps the shell's look instead of the router's default overlay. */
export default function RouteErrorPage() {
  const error = useRouteError()
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Something went wrong while rendering this page.'
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3">
      <ErrorState
        title="This page hit an error"
        message={message}
        onRetry={() => window.location.reload()}
      />
      <Link to="/" className={buttonStyles({ variant: 'secondary', size: 'md' })}>
        Go home
      </Link>
    </div>
  )
}
